import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center text-slate-500 text-sm border-t border-slate-800/50" data-id="element-43">
        <p className="mb-3" data-id="element-44">
          © {new Date().getFullYear()} La Parálisis del Todo o Nada. Todos los
          derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-45">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-slate-300 underline underline-offset-2 transition-colors" data-id="element-46">
            Política de Privacidad
          </button>
          <span className="text-slate-700" data-id="element-47">|</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-slate-300 underline underline-offset-2 transition-colors" data-id="element-48">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-49">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-50">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-[#111827] border border-slate-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-51">
              <div className="flex items-center justify-between p-6 border-b border-slate-700/50" data-id="element-52">
                <h2 className="text-xl font-heading font-bold text-white" data-id="element-53">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-800" data-id="element-54">
                  <X className="w-5 h-5" data-id="element-55" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-slate-300 leading-relaxed space-y-4" data-id="element-56">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-57" /> : <TermsContent data-id="element-58" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-slate-400 text-sm" data-id="element-59">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-60">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-61">
        Al adquirir nuestro producto digital, recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito directamente; estos datos son gestionados de forma
        segura por nuestro procesador de pagos.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-62">
        2. Uso de la Información
      </h3>
      <p data-id="element-63">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 text-slate-400" data-id="element-64">
        <li data-id="element-65">Procesar y entregar tu compra.</li>
        <li data-id="element-66">Enviarte el acceso al producto adquirido.</li>
        <li data-id="element-67">
          Comunicarnos contigo en caso de actualizaciones importantes del
          producto.
        </li>
      </ul>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-68">
        3. Protección de Datos
      </h3>
      <p data-id="element-69">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-70">
        4. Compartición de Datos
      </h3>
      <p data-id="element-71">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros, excepto con los proveedores de servicios necesarios para
        procesar tu compra (procesador de pagos, plataforma de entrega digital).
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-72">5. Cookies</h3>
      <p data-id="element-73">
        Este sitio puede utilizar cookies esenciales para el funcionamiento del
        proceso de compra. No utilizamos cookies de seguimiento publicitario de
        terceros.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-74">6. Tus Derechos</h3>
      <p data-id="element-75">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También puedes solicitar la portabilidad de tus
        datos o retirar tu consentimiento para el tratamiento de los mismos.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-76">
        7. Cambios en esta Política
      </h3>
      <p data-id="element-77">
        Nos reservamos el derecho de actualizar esta política de privacidad.
        Cualquier cambio significativo será comunicado a través de los medios
        disponibles.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-slate-400 text-sm" data-id="element-78">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-79">1. Producto Digital</h3>
      <p data-id="element-80">
        "La Parálisis del Todo o Nada" es un producto digital de contenido
        informativo y educativo. No constituye asesoramiento médico, psicológico
        ni profesional. Si tienes un diagnóstico de TDAH o sospechas que puedes
        tenerlo, consulta con un profesional de la salud.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-81">2. Acceso y Entrega</h3>
      <p data-id="element-82">
        Tras completar la compra, recibirás acceso inmediato al contenido
        digital. El acceso es personal e intransferible.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-83">
        3. Propiedad Intelectual
      </h3>
      <p data-id="element-84">
        Todo el contenido del producto está protegido por derechos de autor.
        Queda prohibida la reproducción, distribución, modificación o reventa
        total o parcial del contenido sin autorización expresa por escrito.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-85">
        4. Política de Reembolso
      </h3>
      <p data-id="element-86">
        Dado que se trata de un producto digital con acceso inmediato, no se
        ofrecen reembolsos una vez entregado el acceso al contenido, salvo en
        casos excepcionales evaluados individualmente.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-87">
        5. Limitación de Responsabilidad
      </h3>
      <p data-id="element-88">
        Los resultados pueden variar según cada persona. No garantizamos
        resultados específicos. El contenido se proporciona "tal cual" con fines
        informativos y educativos. No nos hacemos responsables de decisiones
        tomadas basándose en el contenido del producto.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-89">6. Descargo Médico</h3>
      <p data-id="element-90">
        Este producto no reemplaza el diagnóstico, tratamiento o consejo de un
        profesional de la salud mental. Si experimentas dificultades
        significativas, te recomendamos buscar ayuda profesional.
      </p>

      <h3 className="text-lg font-bold text-white mt-6" data-id="element-91">7. Modificaciones</h3>
      <p data-id="element-92">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor desde su publicación en
        esta página.
      </p>
    </>;
}